import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { PATTERNS } from "../../../util/patterns";
import { months } from "../../../util/CommonLists";
import { ApplicationState } from "../../../store";
import { updateState, states, FirstTermsStates } from "../StateManagement";
import * as common from "../../../util/common";
import * as httpClient from "../../../util/httpClient";
import * as Common from "../../../store/common";
import * as services from "../../../store/service";
import SINComponent from "../SINComponent";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import * as LoginActions from "../../../store/loginService/actions";
import { useButtonText } from "../../commonConstants";
interface IProps {
    setForm: any;
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
    manage: any;
}
const paymentFailMsg = `We're sorry, but your billing information was not able to be processed. Please review the information below for accuracy or enter a new payment method. Make sure the billing address and name below are the same your statements are sent to.`;
const PersonalInformationEnd = ({ setForm, displayData, setRegistrationState, registrationState, registrationLookup, manage }: IProps) => {
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const { register, handleSubmit, errors, watch, setError, setValue, getValues, clearErrors } = useForm({
        mode: "onBlur",
    });
    let history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const LookupType: any = query.get("Type");
    const isBusinessUser = displayData && displayData.isBusinessUser;
    const isDisplayDomain = displayData && displayData.displayCompanyDomainName;
    const displayNoOfEmployees = displayData && displayData.displayNoOfEmployees;
    const [state, setState] = useState({ isLoading: false });
    const [errorMsg, setErrorMsg] = useState("");
    const subscriberDetails = registrationLookup && registrationLookup["subscriberDetails"];
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.isIdfPartner
            : false
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const salesTax: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.salesTax
            ? state.configurationState.salesTax
            : 0.00
    );
    const annualTax: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.annualTax
            ? state.configurationState.annualTax
            : 0.00
    );
    const SubType = query.get("SUBTYPE");
    const Gndrll = query.get("GNDNRLL");
    let selectedCycle = registrationState.PaymentMode.SubscriptionType
        ? registrationState.PaymentMode.SubscriptionType
        : SubType === "ANNUAL"
            ? "annual"
            : "monthly";
    let price: any;
    if (!(Gndrll && Gndrll.includes('PSS'))) {
        if (LookupType == "SSSOFFER" && displayData["billingOptions"] && displayData["billingOptions"].cartPrice) {
            price = selectedCycle 
                ? selectedCycle === "annual"
                    ? displayData["packageLookup"].packagDetails[0].yearlySubscriptionPrice
                    : displayData["packageLookup"].packagDetails[0].monthlySubscriptionPrice
                : displayData["billingOptions"].cartPrice.discountedPackagePrice;
        } else {
            price =
                selectedCycle == "annual"
                    ? displayData?.billingOptions?.cartPrice?.annualPrice
                    : displayData?.billingOptions?.cartPrice?.monthlyPrice;
        }
    }
    else
    {
        price = 0.00;
    }
    const [idfMinimumAgeError, setIdfMinimumAgeError] = useState(false);
    const [idfFutureDateAgeError, setIdfFutureDateAgeError] = useState(false);
    const [isTuCanadaProvider, setIsTuCanadaProvider] = useState(false);
    const [displayDob, setDisplayDob] = useState(false);

    const [sin, setSin] = useState("");
    const [confirmSin, setConfirmSin] = useState("");
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const { t: tLang } = useTranslation();
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const ShowTermsAndConditionScreenFirst: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.showTermsAndConditionScreenFirst
            : false
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const partnerId = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration.partnerConfig.partnerId) {
            return state.configurationState.configuration.partnerConfig.partnerId;
        }
    });
    const isDeviceVerificationActivated = sessionStorage.getItem('activateDeviceVerificationFlag');
    const  isPreviousOrBack = useButtonText()[1];
    const SetPreferencedLanguage = (leng: any, updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.SetPreferencedLanguage(leng, updateUsersLang));
    const checkUserAgeError = () => {
        let errorFound = false;
        const values = getValues();
        const minimumMemberAge = 18;
        try {
            const accountDOBinDateFormate = new Date(`${values["birthDay"]} ${values["birthMonth"]} ${values["birthYear"]}`);
            const age = common.calculate_age(accountDOBinDateFormate);
            const todaysDate = new Date();

            if (age < minimumMemberAge) {
                setIdfMinimumAgeError(true);
                errorFound = true;
            } else {
                setIdfMinimumAgeError(() => false);
            }

            if (todaysDate < accountDOBinDateFormate) {
                setIdfFutureDateAgeError(() => true);
                errorFound = true;
            } else {
                setIdfFutureDateAgeError(() => false);
            }
        } catch {
            setIdfFutureDateAgeError(() => false);
            setIdfMinimumAgeError(() => false);
        }

        return errorFound;
    };
    function onTextBoxChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
        let targetName = event.target.name;
        let targetValue = event.target.value;

        if (errors["confirm-ssn-4-digit"] && errors["confirm-ssn-4-digit"].type === "validate") {
            clearErrors("confirm-ssn-4-digit");
        }

        switch (targetName) {
            case "check-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("check-ssn-2-digit")?.focus();
                }
                break;
            case "check-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("check-ssn-4-digit")?.focus();
                }
                break;
            case "check-ssn-4-digit":
                if (targetValue.length > 3) {
                    document.getElementById("confirm-ssn-3-digit")?.focus();
                }
                break;
            case "confirm-ssn-3-digit":
                if (targetValue.length > 2) {
                    document.getElementById("confirm-ssn-2-digit")?.focus();
                }
                break;
            case "confirm-ssn-2-digit":
                if (targetValue.length > 1) {
                    document.getElementById("confirm-ssn-4-digit")?.focus();
                }
                break;
            default:
                break;
        }
    }
    function getFormattedDate(date: Date) {
        var year = date.getFullYear();

        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : "0" + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : "0" + day;

        return month + "/" + day + "/" + year;
    }

    const formateBirthDate = (personalInfo: any) => {
        if (!personalInfo) return "";
        if (!personalInfo.birthDay || !personalInfo.birthMonth || !personalInfo.birthYear) return "";

        const dateofBirth = new Date(Date.parse(personalInfo.birthMonth + " " + personalInfo.birthDay + ", " + personalInfo.birthYear));
        if (!dateofBirth) return "";

        return getFormattedDate(dateofBirth);
    };
    const getCountryInfo = () => {
        let currentCountry = registrationState && registrationState.addressInfo ? registrationState.addressInfo.country : "";
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };
    let maxL = getCountryInfo() ? 15 : 14;
    let minL = getCountryInfo() ? 7 : 14;
    let validationPhone = getCountryInfo()
        ? register({
            required: true,
            maxLength: maxL,
            minLength: minL,
            pattern: PATTERNS.PHONENUMBER.pattern,
        })
        : register({
            required: true,
            maxLength: maxL,
            minLength: minL,
            pattern: PATTERNS.PHONE.pattern,
        });
    const onSubmit = (personalInfo: any) => {
        const ssn = isTuCanadaProvider ? sin : watch("check-ssn-3-digit") + watch("check-ssn-2-digit") + watch("check-ssn-4-digit");
        const confirmSSN = isTuCanadaProvider ? confirmSin : watch("confirm-ssn-3-digit") + watch("confirm-ssn-2-digit") + watch("confirm-ssn-4-digit");
        if (ssn !== confirmSSN && displayData["displayFullSSN"] && (isIDFPartner ? registrationState.addressInfo.country === "US" : true)) {
            setError("confirm-ssn-4-digit", {
                type: "validate",
            });
            return;
        } else {
            if (displayData["displayFullSSN"]) {
                personalInfo["securityNumber"] = ssn;
                personalInfo["confirmSecurityNumber"] = confirmSSN;

                delete personalInfo["check-ssn-3-digit"];
                delete personalInfo["check-ssn-2-digit"];
                delete personalInfo["check-ssn-4-digit"];
                delete personalInfo["confirm-ssn-3-digit"];
                delete personalInfo["confirm-ssn-2-digit"];
                delete personalInfo["confirm-ssn-4-digit"];
            }
        }

        if (checkUserAgeError()) return;
        if (idfMinimumAgeError || idfFutureDateAgeError) return;
        setState({ ...state, isLoading: true });
        let expMonth = "";
        let expYear = "";
        if (registrationState.billingInfo && registrationState.billingInfo.expirationDate) {
            const expArray = registrationState.billingInfo.expirationDate.split("/");
            expMonth = expArray[0];
            expYear = expArray[1];
        }

        const DOB = formateBirthDate(displayDob ? personalInfo : registrationState.personalInfo);
        const last4DigitSsn = subscriberDetails && subscriberDetails["isAutoEnrollUser"] && subscriberDetails["last4SSN"] ? subscriberDetails["last4SSN"] : null;

        const subscriberInfo: any = {
            Email: registrationState.personalInfo.email,
            FirstName: registrationState.personalInfo.FirstName,
            LastName: registrationState.personalInfo.LastName,
            DateOfBirth: DOB ? DOB : "",
            SSN: personalInfo.confirmSecurityNumber && personalInfo.confirmSecurityNumber.replace(/[^0-9]/g, ""),
            ChekcSSN: personalInfo.confirmSecurityNumber && personalInfo.confirmSecurityNumber.replace(/[^0-9]/g, ""),
            SSN4Digits: displayData["displayLast4SSN"] ? personalInfo.confirmSecurityNumber : last4DigitSsn,
            Address1: registrationState.addressInfo.address1,
            Address2: registrationState.addressInfo.address2,
            City: registrationState.addressInfo.city,
            Urbanization: registrationState.addressInfo.urbanization,
            State: registrationState.addressInfo.state,
            Zip: registrationState.addressInfo.zipcode,
            Country: registrationState.addressInfo.country,
            Phone: registrationState.personalInfo
                ? getCountryInfo()
                    ? registrationState.personalInfo.phoneNumber.replace(/[^0-9+]/g, "")
                    : registrationState.personalInfo.phoneNumber
                : registrationState.personalInfo.phoneNumber,
            SMSNumber: null,
            Password: registrationState.securityInfo.password,
            MfaSmsNumber: getCountryInfo()
                ? registrationState.twoFactorMFA.MfaSmsNumber
                    ? registrationState.twoFactorMFA.MfaSmsNumber.replace(/[^0-9+]/g, "")
                    : registrationState.twoFactorMFA.MfaSmsNumber
                : registrationState.twoFactorMFA.MfaSmsNumber,
            MfaVoiceCallNumber: getCountryInfo()
                ? registrationState.twoFactorMFA.MfaVoiceCallNumber
                    ? registrationState.twoFactorMFA.MfaVoiceCallNumber.replace(/[^0-9+]/g, "")
                    : registrationState.twoFactorMFA.MfaVoiceCallNumber
                : registrationState.twoFactorMFA.MfaVoiceCallNumber,
            RoutingNumber: registrationState.addressInfo.routingNumber ? registrationState.addressInfo.routingNumber : "",
            WrittenInstruction: registrationState.proofInfo.writtenInstruction,
            AutomaticRenewal: registrationState.proofInfo.automaticRenewal,
            AutomaticRenewalTermsAcceptance: registrationState.proofInfo.automaticRenewalTermsAcceptance,
        };
        if (isBusinessUser) {
            subscriberInfo["BusinessName"] = registrationState.personalInfo.BusinessName;
        }
        if (isDisplayDomain) {
            subscriberInfo["CompanyDomain"] = registrationState.personalInfo.CompanyDomain;
        }
        if (displayNoOfEmployees) {
            subscriberInfo["NoOfEmployees"] = registrationState.personalInfo.numberOfEmployees;
        }
        const NotificationPreference = {
            TextAlerts: false,
            EmailIdentityNotification: false,
            PushNotification: false,
            EmailNotification: true,
        };
        let CreditCardDetails = null;
        let EFTDetails = null;
        if (registrationState.billingInfo && registrationState.billingInfo.paymentMethod) {
            if (registrationState.billingInfo.paymentMethod == "CC") {
                CreditCardDetails = {
                    CardType: {
                        Options: null,
                        Selection: registrationState.billingInfo.cardType,
                        ReadOnly: false,
                    },
                    NameOnCard: registrationState.billingInfo.cardholderName?.trimStart(),
                    CardNumber: registrationState.billingInfo.cardNumber,
                    ExpDateMo: expMonth,
                    ExpDateYr: expYear,
                    SecurityCode: registrationState.billingInfo.securityCode,
                };
            }
            if (registrationState.billingInfo.paymentMethod == "EFT") {
                EFTDetails = {
                    nameOnAccount: registrationState.billingInfo.accountName,
                    routingNumber: {
                        options: ["string"],
                        selection: registrationState.billingInfo.routingNumber,
                        readOnly: true,
                    },
                    accountNumber: registrationState.billingInfo.accountNumber,
                    bankName: {
                        options: ["string"],
                        selection: registrationState.billingInfo.bankName,
                        readOnly: true,
                    },
                    accountType: {
                        options: ["string"],
                        selection: registrationState.billingInfo.accountType,
                        readOnly: true,
                    },
                };
            }
        }
        let BillingAddress = null;
        if (registrationState.billingInfo && registrationState.billingInfo.isSameAddress) {
            BillingAddress = {
                Address1: registrationState.addressInfo.address1,
                Address2: registrationState.addressInfo.address2,
                City: registrationState.addressInfo.city,
                State: {
                    Options: null,
                    Selection: registrationState.addressInfo.state,
                    ReadOnly: false,
                },
                ZipCode: registrationState.addressInfo.zipcode,
                Country: null,
            };
        } else {
            BillingAddress = {
                Address1: registrationState.billingInfo.address1,
                Address2: registrationState.billingInfo.address2,
                City: registrationState.billingInfo.city,
                State: {
                    Options: null,
                    Selection: registrationState.billingInfo.state,
                    ReadOnly: false,
                },
                ZipCode: registrationState.billingInfo.zipcode,
                Country: null,
                Phone: null,
            };
        }

        let BillingInformation = null;
        if (displayData.billingRequired) {
            BillingInformation = {
                CreditCardDetails: CreditCardDetails,
                EFTDetails: EFTDetails,
                BillingAddress: BillingAddress,
                PaymentMode: {
                    Options: null,
                    Selection: registrationState.billingInfo.paymentMethod ? registrationState.billingInfo.paymentMethod : "",
                    Name: registrationState.billingInfo.cardholderName ? registrationState.billingInfo.cardholderName : "",
                    SubscriptionType: registrationState.PaymentMode.SubscriptionType == "annual" ? "yearly" : "monthly",
                },
            };
        }
        const preferredLanguage = sessionStorage.getItem('preferredLanguage');
        let languageId = (preferredLanguage === 'en') ? 1 : ((preferredLanguage === 'fr') ? 2 : 1);
        const requestBody = {
            SubscriberInfo: subscriberInfo,
            NotificationPreference: NotificationPreference,
            SecurityQuestionAnswer: registrationState.securityInfo.item,
            BillingInformation: BillingInformation,
            idfDetails: {
                monitorPrimaryEmail: registrationState.monitorPrimaryEmail ? "True" : "False",
            },
            LanguageId: languageId,
        };

        httpClient.sendRequest("POST", "web/Registration/Complete-Registration", requestBody).then(async (data: any) => {
            setState({ ...state, isLoading: false });
            if (data["isSuccess"]) {
                if (data && data.loginResponse) {
                    if (isDeviceVerificationActivated === 'true') {
                        httpClient.sendRequest("PUT", "web/DeviceRisk/UpdateDeviceRiskId");
                    }
                    
                    data.loginResponse.EmailAddress = registrationState.personalInfo.email;
                    const languageRequestBody = {
                        NukeUserId: data.loginResponse.nukeUserId,
                        PartnerId: partnerId,
                        LanguageId: languageId
                    };  
                    try {
                        const setLanguageForSessionRequestBody = {
                            LanguageId: languageId
                        };
                        await httpClient.sendRequest("POST", "api/userServices/language", languageRequestBody).then(async (langData: any) => {
                            await httpClient.sendRequest("POST", "web/login/SetLanguageForSession", setLanguageForSessionRequestBody);
                            SetPreferencedLanguage(preferredLanguage, false);

                        }).catch(async (err: any) => {
                            const setLanguageForSessionRequestBody = {
                                LanguageId: 1
                            };
                            await httpClient.sendRequest("POST", "web/login/SetLanguageForSession", setLanguageForSessionRequestBody);
                            SetPreferencedLanguage("en", false);

                        });  
                    }
                    finally {
                        dispatch({ type: "SUBMIT_LOGIN", userInfo: data.loginResponse });
                        // load user services after successful login
                        dispatch(Common.actionCreators.refreshUserPermission());
                        history.push("/dashboard");
                    }                   
                }
                window.addToDataLayer({
                    event: "purchase",
                    ep: {
                        transaction_id: data.paymentTXRefNum, 
                        value: selectedCycle === "annual" ? "$" + ((parseFloat(price) + annualTax) ? (parseFloat(price) + annualTax).toFixed(2) : "0.00") : "$" + ((parseFloat(price) + salesTax) ? (parseFloat(price) + salesTax).toFixed(2) : "0.00"),
                        tax: selectedCycle === "annual"? annualTax : salesTax, 
                        offer: displayData?.packageLookup?.packagDetails[0].packageName, 
                        billing_type: selectedCycle === "annual" ? "Annual" : "Monthly", 
                        purchase_type: parseFloat(price) > 0 ? "Subscription" : "Partner Paid", 
                    },
                });
            } else {
                if (data && data.status) {
                    switch (data.status) {
                        case "PAYMENT_AUTHORIZE_FAILURE":
                            manage(updateState(states, displayData.billingRequired, 2, paymentFailMsg));
                            break;
                        default:
                            history.push({
                                pathname: "/register/error",
                                state: {
                                    fromRegistration: true,
                                },
                            });
                            break;
                    }
                } else {
                    setErrorMsg("Something went wrong!");
                }
            }
        });
        window.addToDataLayer({ event: "Submit NotificationPreference" });
    };
    const userSelectedBirthDateMonthValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? moment(subscriberDetails["dateOfBirth"]).format("MMM").toString() : "";
    const userSelectedBirthDateDayValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? new Date(subscriberDetails["dateOfBirth"]).getDate().toString() : "";
    const userSelectedBirthDateYearValue =
        subscriberDetails && subscriberDetails["dateOfBirth"] ? moment(subscriberDetails["dateOfBirth"]).format("YYYY").toString() : "";
    const setPrevious = () => {
        if (isTypeSSOProvisional && ShowTermsAndConditionScreenFirst) {
            manage(updateState(FirstTermsStates, displayData.billingRequired, 2));
        } else if (isTypeSSOProvisional) {
            manage(updateState(states, displayData.billingRequired, 2));
        } else {
            manage(updateState(states, displayData.billingRequired, 4));
        }
    };

    const getPackageCode = () => {
        let packageCode;
        const packagDetails = displayData?.packageLookup?.packagDetails;
        if (packagDetails && packagDetails.length > 0) {
            packageCode = packagDetails[0].packageCode;
        }
        return packageCode;
    };

    const dateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-day">Date of Birth Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthDay"
                        className="inputbox"
                        id="label-dob-day"
                        defaultValue={1}
                        onChange={checkUserAgeError}
                    >
                        <option value="">Day</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-month">Date of Birth Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthMonth"
                        className="inputbox"
                        id="label-dob"
                        defaultValue={0}
                        onChange={checkUserAgeError}
                    >
                        <option value="">Month</option>
                        {months.map((month) => {
                            return (
                                <option key={month} value={month}>
                                    {month}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className={`form-row row ${(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) && "status-error"}`}>
                <div className="form-label sr-only col-xs-12 col-no-gutter ">
                    <label htmlFor="label-dob-year">Date of Birth Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register({ required: true })}
                        name="birthYear"
                        className="inputbox"
                        id="label-dob-year"
                        defaultValue={2}
                        onChange={checkUserAgeError}
                    >
                        <option value="">Year</option>
                        {Array(115)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        services.isTuCanadaProvider(getPackageCode()).then((response) => {
            setIsTuCanadaProvider(response.isTuCanadaProvider);
        });

        if (displayData?.displayDOB && !displayData?.isTUUser) {
            setDisplayDob(true);
        }
    }, []);
    return (
        <div className="row" id="content">
            <div className="col-xs">
                {errorMsg && (
                    <div className="notice-container status-warning notice-xl" role="alert" aria-atomic="true">
                        <span role="img" aria-label="info-circle" className="notice-icon">
                            <em className="las la-exclamation-circle"></em>
                        </span>
                        <div className="notice-message">Please review the following error(s):</div>
                        <div className="notice-description">{errorMsg}</div>
                    </div>
                )}
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="row box-title-container">
                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                    <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}
                            <div className={showLogoOnRegistrationScreens ? "col-xs-12 col-sm-6" : ""}>
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName={"user"} />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">
                                        {displayData["displayLast4SSN"] || displayData["displayFullSSN"]
                                            ? "Personal Information"
                                            : tLang("registration.completeRegistration.title")}
                                    </h2>
                                </div>
                            </div>
                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-0 col-sm-6 row flex-end">
                                    <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={state.isLoading ? "box-content loading" : "box-content"}>
                        <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                            <div className="row between-sm">
                                {(displayData["displayLast4SSN"] || displayData["displayFullSSN"]) && (
                                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                                        <p>To finish setting up your {(isAvastId || isAVGId || isAVGTestId) ? "profile" : "account"}, please provide the following information.</p>
                                        <div className="margin-bottom-l"></div>
                                    </div>
                                )}
                                {displayDob && (
                                    <fieldset className={idfFutureDateAgeError || idfMinimumAgeError ? "form-row inline status-error" : "form-row inline"}>
                                        <div className="row">
                                            <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-3" : "col-sm-3"} col-no-gutter`}>
                                                <label className="legend-label" htmlFor="label-dob">Date of Birth</label>
                                            </div>

                                            <div className={`col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-5"} col-no-gutter`}>
                                                <div className="row ">
                                                    {registrationState.addressInfo.country == "US" ? (
                                                        <>
                                                            {dateFields[1]} {dateFields[0]} {dateFields[2]}{" "}
                                                        </>
                                                    ) : registrationState.addressInfo.country == "CA" || registrationState.addressInfo.country == "TW" ? (
                                                        <>
                                                            {dateFields[2]} {dateFields[1]} {dateFields[0]}{" "}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {dateFields[0]} {dateFields[1]} {dateFields[2]}
                                                        </>
                                                    )}

                                                    {idfFutureDateAgeError && <span className="form-error">Members cannot be born at future dates.</span>}
                                                    {idfMinimumAgeError && <span className="form-error">Member must be 18 years old or older</span>}
                                                    {(errors["birthYear"] || errors["birthDay"] || errors["birthMonth"]) &&
                                                        ((errors["birthYear"] && errors["birthYear"].type === "required") ||
                                                            (errors["birthDay"] && errors["birthDay"].type === "required") ||
                                                            (errors["birthMonth"] && errors["birthMonth"].type === "required")) && (
                                                            <span className="form-error">Date of birth is required.</span>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                )}
                                {!isTuCanadaProvider &&
                                    (displayData["displayLast4SSN"] || displayData["displayFullSSN"]) &&
                                    (isIDFPartner ? registrationState.addressInfo.country === "US" : true) && (
                                        <>
                                            <div
                                                className={`form-row inline row ${(errors["securityNumber"] ||
                                                    errors["check-ssn-3-digit"] ||
                                                    errors["check-ssn-2-digit"] ||
                                                    errors["check-ssn-4-digit"]) &&
                                                    "status-error"
                                                    }`}
                                            >
                                                <div className={`form-label col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-3" : "col-sm-3"} col-no-gutter`}>
                                                    <label htmlFor="label-ssn">
                                                        {" "}
                                                        <legend className="legend-label">
                                                            {displayData["displayLast4SSN"] ? "Last 4 digits of SSN" : "Social Security #"}
                                                        </legend>{" "}
                                                    </label>
                                                </div>
                                                <div className={`form-input col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-5"} col-no-gutter`}>
                                                    {!displayData["displayLast4SSN"] ? (
                                                        <div className="form-input row">
                                                            <div className="col-xs-4 col-sm-4 col-no-gutter">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="check-ssn-3-digit"
                                                                    maxLength={3}
                                                                    className="inputbox"
                                                                    autoComplete="off"
                                                                    onChange={onTextBoxChangeHandler}
                                                                    id="label-ssn"
                                                                />
                                                            </div>
                                                            <label className="hide-label" htmlFor="check-ssn-2-digit">
                                                                Social Security # &nbsp;
                                                            </label>
                                                            <div className="col-xs-4 col-sm-3 col-gutter-horizontal">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="check-ssn-2-digit"
                                                                    id="check-ssn-2-digit"
                                                                    maxLength={2}
                                                                    autoComplete="off"
                                                                    className="inputbox"
                                                                    onChange={onTextBoxChangeHandler}
                                                                />
                                                            </div>
                                                            <label className="hide-label" htmlFor="check-ssn-4-digit">
                                                                Social Security # &nbsp; &nbsp;
                                                            </label>
                                                            <div className="col-xs-4 col-sm-5 col-no-gutter">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="check-ssn-4-digit"
                                                                    id="check-ssn-4-digit"
                                                                    maxLength={4}
                                                                    autoComplete="off"
                                                                    className="inputbox"
                                                                    onChange={onTextBoxChangeHandler}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="inputbox"
                                                            id="label-ssn"
                                                            defaultValue={registrationState.personalInfo && registrationState.personalInfo.securityNumber}
                                                            name="securityNumber"
                                                            maxLength={4}
                                                            ref={register({
                                                                required: true,
                                                                pattern: /^(\d{4})|$^[0-9]*$/,
                                                            })}
                                                        />
                                                    )}
                                                    {errors["securityNumber"] && errors["securityNumber"].type === "required" && (
                                                        <span className="form-error">SSN is required.</span>
                                                    )}
                                                    {errors["securityNumber"] && errors["securityNumber"].type === "pattern" && (
                                                        <span className="form-error">Please enter valid SSN.</span>
                                                    )}
                                                    {({ ...errors["check-ssn-3-digit"] }.type === "required" ||
                                                        { ...errors["check-ssn-2-digit"] }.type === "required" ||
                                                        { ...errors["check-ssn-4-digit"] }.type === "required") && (
                                                            <span className="form-error">SSN is required</span>
                                                        )}

                                                    {({ ...errors["check-ssn-3-digit"] }.type === "pattern" ||
                                                        { ...errors["check-ssn-2-digit"] }.type === "pattern" ||
                                                        { ...errors["check-ssn-4-digit"] }.type === "pattern") && (
                                                            <span className="form-error">Please enter valid SSN.</span>
                                                        )}
                                                </div>
                                            </div>
                                            <div
                                                className={`form-row inline row ${(errors["confirmSecurityNumber"] ||
                                                    errors["confirm-ssn-3-digit"] ||
                                                    errors["confirm-ssn-2-digit"] ||
                                                    errors["confirm-ssn-4-digit"]) &&
                                                    "status-error"
                                                    }`}
                                            >
                                                <div className={`form-label col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-3" : "col-sm-3"} col-no-gutter`}>
                                                    <label htmlFor="confirm-ssn-3-digit">
                                                        <legend className="legend-label">
                                                            {!displayData.displayLast4SSN ? "Confirm Social Security #" : "Confirm Last 4 digits of SSN"}
                                                        </legend>{" "}
                                                    </label>
                                                </div>
                                                <div className={`form-input col-xs-12 ${displayData["displayFullSSN"] ? "col-sm-5" : "col-sm-5"} col-no-gutter`}>
                                                    {!displayData.displayLast4SSN ? (
                                                        <div className="form-input row">
                                                            <div className="col-xs-4 col-sm-4 col-no-gutter">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(?!0{3})(\d{3})(?!-?0{3})(|-\d{3})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="confirm-ssn-3-digit"
                                                                    id="confirm-ssn-3-digit"
                                                                    maxLength={3}
                                                                    className="inputbox"
                                                                    autoComplete="off"
                                                                    onChange={onTextBoxChangeHandler}
                                                                />
                                                            </div>
                                                            <label className="hide-label" htmlFor="confirm-ssn-2-digit">
                                                                Confirm Social Security # &nbsp;
                                                            </label>
                                                            <div className="col-xs-4 col-sm-3 col-gutter-horizontal">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(\d{2})(?!-?0{2})(|-\d{2})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="confirm-ssn-2-digit"
                                                                    id="confirm-ssn-2-digit"
                                                                    maxLength={2}
                                                                    autoComplete="off"
                                                                    className="inputbox"
                                                                    onChange={onTextBoxChangeHandler}
                                                                />
                                                            </div>
                                                            <label className="hide-label" htmlFor="confirm-ssn-4-digit">
                                                                Confirm Social Security # &nbsp; &nbsp;
                                                            </label>
                                                            <div className="col-xs-4 col-sm-5 col-no-gutter">
                                                                <input
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: /(^(?!0{4})(\d{4})(?!-?0{4})(|-\d{4})?$)/,
                                                                    })}
                                                                    type={"password"}
                                                                    name="confirm-ssn-4-digit"
                                                                    id="confirm-ssn-4-digit"
                                                                    maxLength={4}
                                                                    autoComplete="off"
                                                                    className="inputbox"
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="inputbox"
                                                            id="confirm-ssn-3-digit"
                                                            name="confirmSecurityNumber"
                                                            maxLength={4}
                                                            ref={register({
                                                                required: true,
                                                                pattern: /^(\d{4})|$^[0-9]*$/,
                                                                validate: (value) => value === watch("securityNumber") || "Confirm security number do not match.",
                                                            })}
                                                            defaultValue={registrationState.personalInfo && registrationState.personalInfo.confirmSecurityNumber}
                                                        />
                                                    )}
                                                    {errors["confirmSecurityNumber"] && errors["confirmSecurityNumber"].type === "validate" && (
                                                        <span className="form-error">Confirm SSN does not match.</span>
                                                    )}
                                                    {errors["confirmSecurityNumber"] && errors["confirmSecurityNumber"].type === "required" && (
                                                        <span className="form-error">Confirm SSN is required.</span>
                                                    )}
                                                    {errors["confirmSecurityNumber"] && errors["confirmSecurityNumber"].type === "pattern" && (
                                                        <span className="form-error">Please enter valid Confirm SSN.</span>
                                                    )}

                                                    {({ ...errors["confirm-ssn-3-digit"] }.type === "required" ||
                                                        { ...errors["confirm-ssn-2-digit"] }.type === "required" ||
                                                        { ...errors["confirm-ssn-4-digit"] }.type === "required") && (
                                                            <span className="form-error">Confirm SSN is required.</span>
                                                        )}

                                                    {({ ...errors["confirm-ssn-3-digit"] }.type === "pattern" ||
                                                        { ...errors["confirm-ssn-2-digit"] }.type === "pattern" ||
                                                        { ...errors["confirm-ssn-4-digit"] }.type === "pattern") && (
                                                            <span className="form-error">Please enter valid Confirm SSN.</span>
                                                        )}
                                                    {errors["confirm-ssn-4-digit"] && errors["confirm-ssn-4-digit"].type === "validate" && (
                                                        <span className="form-error">Confirm SSN does not match.</span>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                {/*{isTuCanadaProvider &&
                  <SINComponent
                    setSin={setSin}
                    setConfirmSin={setConfirmSin}
                    displayData={displayData}
                    registrationState={registrationState}
                  >
                  </SINComponent>
                }*/}
                            </div>

                            <div className="col-xs-12 col-sm-12 col-no-gutter">
                                <div className="margin-bottom-xl"></div>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className={`form-row inline row}`}>
                                            {/*<p>*/}
                                            {/*  Click <span className="strong">'Done' </span>{`below to*/}
                                            {/*  enter your account ${isTypeSSOProvisional ? 'Hub' : 'Dashboard'}. You can update or add*/}
                                            {/*  information on your ${isTypeSSOProvisional ? 'Hub' : 'Dashboard'} or under ${isTypeSSOProvisional ? "" : "Manage"} Account at*/}
                                            {/*  any time.`}*/}
                                            {/*                    </p>*/}

                                            <p>
                                                {tLang("registration.completeRegistration.messageClick")}
                                                <span className="strong">{` '${tLang("registration.completeRegistration.messageDone")}' `}</span>
                                                {renderSiteInIFrame && isTypeSSOProvisional
                                                    ? tLang("registration.completeRegistration.messageHub")
                                                    : (isAvastId || isAVGId || isAVGTestId)
                                                        ? tLang("registration.completeRegistration.messageDashboardForAvast")
                                                        : isTypeSSOProvisional
                                                            ? tLang("registration.completeRegistration.messageDashboard")
                                                            : !isTypeSSOProvisional
                                                                ? tLang("registration.completeRegistration.messageDashboard")
                                                                : ""}
                                            </p>
                                        </div>
                                        {/* <div className="margin-bottom-xl"></div>
                    <div className={`form-row inline row}`}>
                      <p className="strong">
                        You can update or add information on your
                        Dashboard or under Manage Account at any time.
                      </p>
                    </div> */}
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-no-gutter">
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li className="margin-left-s">
                                                <button
                                                    type="button"
                                                    className="btn-default
                                            btn-default btn-min-width"
                                                    onClick={() => setPrevious()}
                                                >
                                                    <span className="btn-text">{isPreviousOrBack}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                                    <span className="btn-text">{tLang("registration.completeRegistration.doneBtn")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PersonalInformationEnd;
